import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import VideoClass from '~/common/utils/video';

import styles from './video-modal.css';

@withRouter
@inject('modalStore')
@observer

export default class VideoModal extends Component {
    state = {
        videoClass: null
    }
    componentDidMount() {
        const { modalStore: { modalProps } } = this.props;
        this.state.videoClass = new VideoClass(modalProps.videoId);
        this.playVideo();
    }

    componentWillUnmount() {
        this.state.videoClass.closeModal();
    }

    playVideo() {
        this.state.videoClass.openModal();
    }

    render() {
        return (
            <div className={styles['video-player']} id='player'>
            </div>
        );
    }
}

